import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Users, Globe, Lock, Link2, Video, Inbox } from 'lucide-react';
import { toast } from 'sonner';

export const MeetingLinkButton = ({ link, testId }) =>
  link ? (
    <Button asChild className="bg-emerald-600 hover:bg-emerald-700 text-white rounded-full" data-testid={testId}>
      <a href={link} target="_blank" rel="noopener noreferrer"><Video className="w-4 h-4 mr-2" />Join Meeting</a>
    </Button>
  ) : null;

const isActive = (b) => b.booking_status !== 'cancelled' && b.payment_status !== 'rejected';

export const GroupBadges = ({ booking }) => {
  if ((booking.group_size || 1) < 2) return null;
  const filled = 1 + (booking.participants || []).length;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Badge className="bg-violet-100 text-violet-700 border-violet-300" data-testid={`booking-places-${booking.id}`}>
        <Users className="w-3.5 h-3.5 mr-1" />{filled}/{booking.group_size} places filled
      </Badge>
      <Badge variant="outline" data-testid={`booking-visibility-${booking.id}`}>
        {booking.visibility === 'discoverable' ? <><Globe className="w-3 h-3 mr-1" />Discoverable</> : <><Lock className="w-3 h-3 mr-1" />Invite only</>}
      </Badge>
      {(booking.participants || []).length > 0 && (
        <span className="text-xs text-slate-500">With {booking.participants.map((p) => p.name).join(', ')}</span>
      )}
    </div>
  );
};

export const GroupActions = ({ booking, onOpenRequests }) => {
  if ((booking.group_size || 1) < 2 || !isActive(booking)) return null;
  const copyInvite = async () => {
    const url = `${window.location.origin}/sessions/${booking.id}`;
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Invite link copied — share it with your friends');
    } catch (e) {
      toast.info(url);
    }
  };
  return (
    <>
      <Button variant="outline" className="rounded-full" onClick={() => onOpenRequests(booking)} data-testid={`join-requests-button-${booking.id}`}>
        <Inbox className="w-4 h-4 mr-2" />Join Requests
        {booking.pending_join_requests > 0 && (
          <span className="ml-2 rounded-full bg-rose-500 text-white text-[10px] font-bold px-1.5 py-0.5" data-testid={`pending-requests-count-${booking.id}`}>
            {booking.pending_join_requests}
          </span>
        )}
      </Button>
      <Button variant="outline" className="rounded-full border-violet-300 text-violet-700 hover:bg-violet-50 hover:text-violet-800" onClick={copyInvite} data-testid={`copy-invite-${booking.id}`}>
        <Link2 className="w-4 h-4 mr-2" />Copy Invite Link
      </Button>
    </>
  );
};
